angular.module('components.caImportFileList', [])
    .component('caImportFileList', {
        templateUrl: 'main/product/productimport/components/filelist.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            importType: '<',
            onImportFileChanged: '&'
        },
        controller: controller
    });

// @ngInject
function controller($state, $scope, FileDataImportApiServiceV2, $translate, loadSpinnerService, ToasterService) {
    var vm = this;

    //Properties
    var fileInputDomElement = $("#xlf")[0];
    vm.currentPage = 1;
    vm.totalItems = 0;
    vm.itemsPerPage = 15;
    vm.importFiles = [];
    vm.showReload = false;

    //Methods
    vm.loadImportFiles = loadImportFiles;
    vm.reloadFile = reloadFile;
    vm.deleteImportFile = deleteImportFile;
    vm.goToOrder = goToOrder;
    vm.goToEditor = goToEditor;

    activate();

    function activate() {
        fileInputDomElement.addEventListener('change', function handleImportFileChanged(e) {
            var files = e.target.files;
            vm.importFileName = files[0].name;
            var i,f;
            for (i = 0, f = files[i]; i !== files.length; ++i) {
                vm.onImportFileChanged({ file: f });
                vm.showReload = true;
            }
        }, false);
        $scope.$watch(function() { return vm.importType; }, function(oldValue, newValue) {
            if (oldValue !== newValue) {
                if (!vm.importFiles || vm.importFiles.length === 0) {
                    loadImportFiles();
                }
                //if (oldValue === 'existingImportFile') {
                //    $('.col-lg-6').css('width', '100%');
                //} else {
                //    $('.col-lg-6').css('width', '50%');
                //}
            }
        });
        loadImportFiles();
    }

    function loadImportFiles() {
        loadSpinnerService.start('mainSpinner');
        FileDataImportApiServiceV2.getImportFiles(vm.currentPage, vm.searchTerm, vm.itemsPerPage).then(function(response) {
            vm.totalItems = response.totalItems;
            vm.importFiles = response.data;
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant('productimport.errorWhileReadingImportFileList'), $translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function reloadFile() {
        var target = $(fileInputDomElement)[0];
        var files = target.files;
        var i,f;
        for (i = 0, f = files[i]; i !== files.length; ++i) {
            vm.onImportFileChanged({ file: f, revalidate: true });
            vm.showReload = true;
        }
    }

    function deleteImportFile(importId) {
        loadSpinnerService.start('mainSpinner');
        FileDataImportApiServiceV2.deleteProductImportFile(importId).then(function() {
            var deletedItem = _.find(vm.importFiles, function(importFile) {
                return importFile.id === importId;
            });

            vm.importFiles = _.without(vm.importFiles, deletedItem);
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant('productimport.errorWhileDeletingImportFile'), $translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function goToOrder(order) {
        $state.go('order.modifyorder', { orderId: order.id });
    }

    function goToEditor(file) {
        $state.go('product.productimporteditor', { importFileId: file.id });
    }
}
